import { setCookie, getCookie } from "../helpers/cookie";
import { mainNavigation } from "./mainNavigation";

export class Alert {
    private alert: HTMLElement;
    private closeButton: HTMLButtonElement;
    private cookieNameBase: string = "alert_banner";
    private cookiecontent: string | null = null;
    private uniqueCookieName: string | null = null;
    constructor(alert: HTMLElement) {
        this.alert = alert;
        this.closeButton = this.alert.querySelector("[data-close]");
        this.init();
    }
    init = () => {
        this.cookiecontent = this.alert.getAttribute("date-updated");
        this.uniqueCookieName = this.cookieNameBase + "_" + this.cookiecontent; 
        //Check if the cookie exists, if it doesn't show the alert
        if (getCookie(this.uniqueCookieName) === null) {
            this.alert.removeAttribute('hidden');
        }
        this.activateCloseButton();
        if ((window as any).mainNavigation) mainNavigation.setCssVariables();//Updates css variables
    }

    activateCloseButton = () => {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => {
                this.alert.setAttribute('hidden', 'true');
                if (this.cookiecontent) {
                    setCookie(this.uniqueCookieName, this.cookiecontent, 1000);
                }
                if ((window as any).mainNavigation) mainNavigation.updateNavHeight();//Updates css variables
            });
        }
    }
}